import { Chip } from '@ds';
import { getBgColorByInvoiceStatus } from '../utils';
import { InvoiceStatus } from '@/api/apis/case';
import { invoiceStatusNames } from '@/constants/case/case.constants';

type InvoiceStatusChipsProps = {
  status: InvoiceStatus;
};

export const InvoiceStatusChips = ({ status }: InvoiceStatusChipsProps) => (
  <Chip className={`h-[24px] ${getBgColorByInvoiceStatus(status)}`}>
    <span className="text-white">{invoiceStatusNames[status]}</span>
  </Chip>
);
